export default function ChangeLog() {
  return (
    <div>
      <h3>7/2/21</h3>
      <article>
        <b>added</b>
        <ul>
          <li>Free demon for Lords of Hell</li>
        </ul>
        <b>on deck</b>
        <ul>
          <li>Import/Export for roster</li>
          <li>Post Game effects</li>
        </ul>
      </article>
      <h3>6/29/21</h3>
      <article>
        <b>added</b>
        <ul>
          <li>Routing (you can read this changelog now)</li>
          <li>On github now!</li>
        </ul>
        <b>on deck</b>
        <ul>
          <li>Free demon for Lords of Hell</li>
          <li>Import/Export for roster</li>
        </ul>
      </article>
      <h3>6/26/21</h3>
      <article>
        <b>added</b>
        <ul>
          <li>Naming for demons</li>
          <li>
            Horizontal separation for demons to avoid text running together
          </li>
        </ul>
        <b>on deck</b>
        <ul>
          <li>Free demon for Lords of Hell</li>
          <li>Adding routing to app so this changelog can live somewhere</li>
          <li>Import/Export for roster</li>
        </ul>
      </article>
    </div>
  );
}
